// extracted by mini-css-extract-plugin
export var container = "recents-module--container--3_W-m";
export var title = "recents-module--title--2sxzc";
export var results = "recents-module--results--1jCn_";
export var row = "recents-module--row--AiJbH";
export var resultcard = "recents-module--resultcard--3DwQS";
export var logo = "recents-module--logo--17Mrk";
export var logoCut = "recents-module--logoCut--1Ym7U";
export var score = "recents-module--score--GD4fk";
export var gameTitle = "recents-module--gameTitle--1-BrY";
export var logoImage = "recents-module--logoImage--FgJqc";
export var logoCutImage = "recents-module--logoCutImage--3R6Hg";
export var column = "recents-module--column--3m8Pr";
export var containerSM = "recents-module--containerSM--1knIR";
export var titleSM = "recents-module--titleSM--2twmB";
export var rowSM = "recents-module--rowSM--3aIWf";
export var resultcardSM = "recents-module--resultcardSM--20b6O";
export var logoSM = "recents-module--logoSM--3rhWz";
export var scoreSM = "recents-module--scoreSM--2loqh";
export var gameTitleSM = "recents-module--gameTitleSM--TlNvj";
export var containerMobile = "recents-module--containerMobile--vrSH3";
export var columnMobile = "recents-module--columnMobile--27oz_";
export var resultcardmobile = "recents-module--resultcardmobile--11i7U";
export var gameTitleMobile = "recents-module--gameTitleMobile--2NlPh";
export var logoMobile = "recents-module--logoMobile--3Ym5k";
export var logoMobile2 = "recents-module--logoMobile2--2KGHf";
export var logoMobile3 = "recents-module--logoMobile3--2JJTO";
export var scoreMobile = "recents-module--scoreMobile--3-7E5";
export var titleMobile = "recents-module--titleMobile--2dpUH";